import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import formatNumberWithAbbreviation from '../../utils/numberMeasurementFormat';

const IndicatorValue = ({
  indicatorSubtitle, indicatorValuePrimary, indicatorPercentage, indicatorValueSecondary,
  indicatorMeasureUnitPrimary, indicatorMeasureUnitSecondary, indicatorCustomClass, indicatorId,
  indicatorValuePrimaryDigits, indicatorValueSecondaryDigits, indicatorPercentageDigits,
}) => {
  const currentUserLanguage = localStorage.getItem('bi.userLanguage');

  const formattedIndicatorValuePrimary = indicatorValuePrimary
  || indicatorValuePrimary === 0
    ? formatNumberWithAbbreviation(
      indicatorValuePrimary, indicatorValuePrimaryDigits, currentUserLanguage,
    ) : null;
  const formattedIndicatorValueSecondary = indicatorValueSecondary
  || indicatorValueSecondary === 0
    ? formatNumberWithAbbreviation(
      indicatorValueSecondary, indicatorValueSecondaryDigits, currentUserLanguage,
    ) : null;
  const formattedIndicatorPercentage = indicatorPercentage
  || indicatorPercentage === 0 ? formatNumberWithAbbreviation(
      indicatorPercentage, indicatorPercentageDigits, currentUserLanguage,
    ) : null;

  return (
    <div id={indicatorId} className={`card-indicator__indicator ${indicatorCustomClass}`}>
      {indicatorSubtitle && (
        <span className="card-indicator__subtitle" data-testid="card-indicator__subtitle">
          {indicatorSubtitle}
        </span>
      )}

      <div className="card-indicator__values-container">
        {(formattedIndicatorValuePrimary || formattedIndicatorValuePrimary === 0) && (
          <span className="card-indicator__val card-indicator__value card-indicator__value--primary" data-testid="card-indicator__value--primary">
            {formattedIndicatorValuePrimary}
          </span>
        )}

        {(formattedIndicatorPercentage || formattedIndicatorPercentage === 0) && (
          <span className="card-indicator__val card-indicator__percentage" data-testid="card-indicator__percentage">
            {formattedIndicatorPercentage}%
          </span>
        )}

        {indicatorMeasureUnitPrimary && (
          <span className="card-indicator__measure-unit card-indicator__measure-unit--primary" data-testid="card-indicator__measure-unit--primary">
            {indicatorMeasureUnitPrimary}
          </span>
        )}

        {(formattedIndicatorValueSecondary || formattedIndicatorValueSecondary === 0) && (
          <span className="card-indicator__val card-indicator__value card-indicator__value--secondary" data-testid="card-indicator__value--secondary">
            / {formattedIndicatorValueSecondary}
          </span>
        )}

        {indicatorMeasureUnitSecondary && (
          <span className="card-indicator__measure-unit card-indicator__measure-unit--secondary" data-testid="card-indicator__measure-unit--secondary">
            {indicatorMeasureUnitSecondary}
          </span>
        )}
      </div>
    </div>

  );
};

const EpCardIndicator = ({
  indicatorType, indicatorTitle, indicatorSubtitle, indicatorValuePrimary, indicatorPercentage,
  indicatorValueSecondary, indicatorMeasureUnitPrimary, indicatorMeasureUnitSecondary,
  indicatorCustomClass, indicatorName, indicatorValuePrimaryDigits, indicatorValueSecondaryDigits,
  indicatorPercentageDigits,
}) => {
  let indicator = (
    <>
      <IndicatorValue
        indicatorId={`card-indicator__indicator--${indicatorName}`}
        indicatorCustomClass={`card-indicator__indicator ${indicatorCustomClass && indicatorCustomClass}`}
        indicatorValuePrimary={indicatorValuePrimary}
        indicatorPercentage={indicatorPercentage}
        indicatorValueSecondary={indicatorValueSecondary}
        indicatorMeasureUnitPrimary={indicatorMeasureUnitPrimary}
        indicatorMeasureUnitSecondary={indicatorMeasureUnitSecondary}
        indicatorValuePrimaryDigits={indicatorValuePrimaryDigits}
        indicatorValueSecondaryDigits={indicatorValueSecondaryDigits}
        indicatorPercentageDigits={indicatorPercentageDigits}
      />
    </>
  );

  if (indicatorType === 'double-indicators') {
    indicator = (
      <>
        <IndicatorValue
          indicatorId={`card-indicator__indicator--${indicatorName[0]}`}
          indicatorCustomClass={`card-indicator__indicator ${indicatorCustomClass && indicatorCustomClass[0]}`}
          indicatorSubtitle={indicatorSubtitle && indicatorSubtitle[0]}
          indicatorValuePrimary={indicatorValuePrimary && indicatorValuePrimary[0]}
          indicatorPercentage={indicatorPercentage && indicatorPercentage[0]}
          indicatorValueSecondary={indicatorValueSecondary && indicatorValueSecondary[0]}
          indicatorMeasureUnitPrimary={indicatorMeasureUnitPrimary
            && indicatorMeasureUnitPrimary[0]}
          indicatorMeasureUnitSecondary={indicatorMeasureUnitSecondary
            && indicatorMeasureUnitSecondary[0]}
          indicatorValuePrimaryDigits={indicatorValuePrimaryDigits
            && indicatorValuePrimaryDigits[0]}
          indicatorValueSecondaryDigits={indicatorValueSecondaryDigits
            && indicatorValueSecondaryDigits[0]}
          indicatorPercentageDigits={indicatorPercentageDigits && indicatorPercentageDigits[0]}
        />
        <IndicatorValue
          indicatorId={`card-indicator__indicator--${indicatorName[1]}`}
          indicatorCustomClass={`card-indicator__indicator ${indicatorCustomClass && indicatorCustomClass[1]}`}
          indicatorSubtitle={indicatorSubtitle && indicatorSubtitle[1]}
          indicatorValuePrimary={indicatorValuePrimary && indicatorValuePrimary[1]}
          indicatorPercentage={indicatorPercentage && indicatorPercentage[1]}
          indicatorValueSecondary={indicatorValueSecondary && indicatorValueSecondary[1]}
          indicatorMeasureUnitPrimary={indicatorMeasureUnitPrimary
            && indicatorMeasureUnitPrimary[1]}
          indicatorMeasureUnitSecondary={indicatorMeasureUnitSecondary
             && indicatorMeasureUnitSecondary[1]}
          indicatorValuePrimaryDigits={indicatorValuePrimaryDigits
            && indicatorValuePrimaryDigits[1]}
          indicatorValueSecondaryDigits={indicatorValueSecondaryDigits
            && indicatorValueSecondaryDigits[1]}
          indicatorPercentageDigits={indicatorPercentageDigits && indicatorPercentageDigits[1]}
        />
      </>
    );
  }

  return (
    <div className={`card-indicator card-indicator--${indicatorType}`} data-testid="card-indicator">
      <span className="card-indicator__title" data-testid="card-indicator__title">{indicatorTitle}</span>

      <div className="card-indicator__indicators">
        {indicator}
      </div>
    </div>
  );
};

export default EpCardIndicator;

IndicatorValue.defaultProps = {
  indicatorSubtitle: null,
  indicatorValuePrimary: null,
  indicatorPercentage: null,
  indicatorValueSecondary: null,
  indicatorMeasureUnitPrimary: null,
  indicatorMeasureUnitSecondary: null,
  indicatorCustomClass: null,
  indicatorValuePrimaryDigits: [1, 1],
  indicatorValueSecondaryDigits: [1, 1],
  indicatorPercentageDigits: [2, 2],
};

IndicatorValue.propTypes = {
  indicatorSubtitle: PropTypes.string,
  indicatorValuePrimary: PropTypes.oneOfType([PropTypes.number,
    PropTypes.arrayOf(PropTypes.number)]),
  indicatorPercentage: PropTypes.oneOfType([PropTypes.number,
    PropTypes.arrayOf(PropTypes.number)]),
  indicatorValueSecondary: PropTypes.oneOfType([PropTypes.number,
    PropTypes.arrayOf(PropTypes.number)]),
  indicatorMeasureUnitPrimary: PropTypes.oneOfType([PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)]),
  indicatorMeasureUnitSecondary: PropTypes.oneOfType([PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)]),
  indicatorCustomClass: PropTypes.string,
  indicatorId: PropTypes.string.isRequired,
  indicatorValuePrimaryDigits: PropTypes.oneOfType([PropTypes.number,
    PropTypes.arrayOf(PropTypes.number)]),
  indicatorValueSecondaryDigits: PropTypes.oneOfType([PropTypes.number,
    PropTypes.arrayOf(PropTypes.number)]),
  indicatorPercentageDigits: PropTypes.oneOfType([PropTypes.number,
    PropTypes.arrayOf(PropTypes.number)]),
};

EpCardIndicator.defaultProps = {
  indicatorTitle: null,
  indicatorSubtitle: null,
  indicatorValuePrimary: null,
  indicatorPercentage: null,
  indicatorValueSecondary: null,
  indicatorMeasureUnitPrimary: null,
  indicatorMeasureUnitSecondary: null,
  indicatorCustomClass: null,
  indicatorValuePrimaryDigits: 0,
  indicatorValueSecondaryDigits: 0,
  indicatorPercentageDigits: 1,
};

EpCardIndicator.propTypes = {
  indicatorType: PropTypes.oneOf(['single-value', 'double-values', 'double-indicators']).isRequired,
  indicatorTitle: PropTypes.string,
  indicatorSubtitle: PropTypes.arrayOf(PropTypes.string),
  indicatorValuePrimary: PropTypes.oneOfType([PropTypes.number,
    PropTypes.arrayOf(PropTypes.number)]),
  indicatorPercentage: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  indicatorValueSecondary: PropTypes.oneOfType([PropTypes.number,
    PropTypes.arrayOf(PropTypes.number)]),
  indicatorMeasureUnitPrimary: PropTypes.oneOfType([PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)]),
  indicatorMeasureUnitSecondary: PropTypes.oneOfType([PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)]),
  indicatorCustomClass: PropTypes.string,
  indicatorName: PropTypes.string.isRequired,
  indicatorValuePrimaryDigits: PropTypes.oneOfType([PropTypes.number,
    PropTypes.arrayOf(PropTypes.number)]),
  indicatorValueSecondaryDigits: PropTypes.oneOfType([PropTypes.number,
    PropTypes.arrayOf(PropTypes.number)]),
  indicatorPercentageDigits: PropTypes.oneOfType([PropTypes.number,
    PropTypes.arrayOf(PropTypes.number)]),
};
